import { render, staticRenderFns } from "./PanelChangelog.vue?vue&type=template&id=652bb6ac&scoped=true&"
import script from "./PanelChangelog.vue?vue&type=script&lang=js&"
export * from "./PanelChangelog.vue?vue&type=script&lang=js&"
import style0 from "./PanelChangelog.vue?vue&type=style&index=0&id=652bb6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652bb6ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652bb6ac')) {
      api.createRecord('652bb6ac', component.options)
    } else {
      api.reload('652bb6ac', component.options)
    }
    module.hot.accept("./PanelChangelog.vue?vue&type=template&id=652bb6ac&scoped=true&", function () {
      api.rerender('652bb6ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelChangelog.vue"
export default component.exports